// extracted by mini-css-extract-plugin
export var cursosList = "Docentes-module--cursos-list--eTORa";
export var title = "Docentes-module--title--3lKlA";